<app-deprecated-modal-form
    #modalForm
    [form]="positionForm"
    (save)="onSave()"
    (cancel)="onCancel()"
    headerText="{{ 'company.position.editPositionDialogHeader' | translate }}"
>
    <app-position-form #positionForm [position]="position"></app-position-form>
</app-deprecated-modal-form>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-header title="{{ 'company.position.header' | translate }}" [back]="true" [contextMenu]="true">
        <app-context-item
            *permission="editPermission; all: true"
            label="{{ 'company.position.deletePositionButtonLabel' | translate }}"
            (click)="onDelete()"
        ></app-context-item>
    </app-header>

    <div class="ui segment">
        <app-segment-header
            [title]="position?.title"
            (edit)="modalForm.show()"
            [editPermission]="editPermission"
        ></app-segment-header>
        <form class="ui static form" [innerHtml]="position?.description ?? '' | sanitizeHtml"></form>
    </div>
</div>

<app-deprecated-confirmation-dialog
    #confirmDeleteDialog
    [negative]="true"
    [label]="'company.position.deletePositionButtonLabel' | translate"
></app-deprecated-confirmation-dialog>
